import { GlobalSearchResultsItem } from '../../types/responses/global-search'
import { apiService } from './apiService'

class GlobalSearchService {
  async search(searchTerm: string): Promise<GlobalSearchResultsItem> {
    const response = await apiService.get('/global-search', {
      params: { searchTerm },
    })

    return response.data
  }
}

const globalSearchService = new GlobalSearchService()

export default globalSearchService
